import { render, staticRenderFns } from "./hallItem.vue?vue&type=template&id=24dab120"
import script from "./hallItem.vue?vue&type=script&lang=js"
export * from "./hallItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports